// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    layout = "layout",
    gap = "gap",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.layout]: "twoColumn" | "stacked";
        [fields.gap]: number;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    mobileShowResults: state.store.data.valveConfigurator.mobileShowResults,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

// Hide the form on mobile when results are shown; hide the results column on mobile until the user submits.
// Above 991px both columns are always rendered side-by-side.
const formMobileHidden = css`
    @media (max-width: 991px) {
        display: none;
    }
`;

const previewMobileHidden = css`
    @media (max-width: 991px) {
        display: none;
    }
`;

const ValveConfiguratorColumnsWidget: React.FC<Props> = ({ id, fields: { layout, gap }, mobileShowResults }) => {
    const isStacked = layout === "stacked";
    const gapPx = typeof gap === "number" ? gap : 20;

    const formItem = (
        <GridItem
            key="form"
            width={isStacked ? 12 : [12, 12, 5, 5, 5]}
            css={mobileShowResults ? formMobileHidden : undefined}
        >
            <Zone contentId={id} zoneName="ValveForm" />
        </GridItem>
    );

    const previewItems = (
        <GridItem
            key="preview"
            width={isStacked ? 12 : [12, 12, 7, 7, 7]}
            css={css`
                display: flex;
                flex-direction: column;
                gap: ${pxToRem(gapPx)};
                ${!mobileShowResults ? previewMobileHidden : ""}
            `}
        >
            <Zone contentId={id} zoneName="ValveImage" />
            <Zone contentId={id} zoneName="ValveBom" />
            <Zone contentId={id} zoneName="ValveSpareParts" />
        </GridItem>
    );

    return <GridContainer gap={gapPx}>{[formItem, previewItems]}</GridContainer>;
};

const ConnectedWidget = connect(mapStateToProps)(ValveConfiguratorColumnsWidget);

const widgetModule: WidgetModule = {
    component: ConnectedWidget,
    definition: {
        group: "Products",
        icon: "distribute-spacing-vertical",
        displayName: "Valve Configurator - Columns Layout",
        fieldDefinitions: [
            {
                name: fields.layout,
                displayName: "Layout",
                editorTemplate: "DropDownField",
                defaultValue: "twoColumn",
                fieldType: "General",
                sortOrder: 1,
                options: [
                    { displayName: "Two column (Form left, Preview/BOM/Spares right)", value: "twoColumn" },
                    { displayName: "Stacked (single column)", value: "stacked" },
                ],
            },
            {
                name: fields.gap,
                displayName: "Gap between items (px)",
                editorTemplate: "IntegerField",
                defaultValue: 20,
                fieldType: "General",
                min: 0,
                max: 100,
                sortOrder: 2,
            },
        ],
    },
};

export default widgetModule;
